import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import '../../styles/shared/Pagination.css';

function Pagination({ page, pageSize, total, onPageChange, busy = false, itemLabel = 'items' }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const current = Math.min(page, totalPages - 1);
  const from = total === 0 ? 0 : current * pageSize + 1;
  const to = Math.min(total, (current + 1) * pageSize);

  const canPrev = current > 0 && !busy;
  const canNext = current < totalPages - 1 && !busy;

  return (
    <div className="pagination">
      <span className="pagination__summary">
        {total === 0
          ? `No ${itemLabel}`
          : <>Showing <strong>{from}–{to}</strong> of {total} {itemLabel}</>}
      </span>
      <div className="pagination__controls">
        <button
          type="button"
          className="pagination__btn"
          onClick={() => canPrev && onPageChange(current - 1)}
          disabled={!canPrev}
          aria-label="Previous page"
        >
          <ChevronLeft size={15} />
        </button>
        <span className="pagination__page">Page {current + 1} / {totalPages}</span>
        <button
          type="button"
          className="pagination__btn"
          onClick={() => canNext && onPageChange(current + 1)}
          disabled={!canNext}
          aria-label="Next page"
        >
          <ChevronRight size={15} />
        </button>
      </div>
    </div>
  );
}

export default Pagination;
